module.exports = __webpack_public_path__ + "1aae9b096174330dcf9e90bbe96f1b38.pdf";